<template>
<div>
    <smallbutton toplabel="Rename" @click="start()" v-if="showButton" :buttonclass="buttonclass"/>
    <linkbutton toplabel="Rename" @click="start()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Rename Product Group</label>
                <br/>
                
            
                <formentry   label="Name"  v-model="productGroup.name" :isrequired="trueParam" />
                
                <div>
                    <label for="" class="required">{{requiredFieldLabel}}</label>
                </div>

                
                <smallbutton  @click="save()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
export default {
    name:'renamegroup',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton
    },
    props:{
        
        showButton:{
            type:Boolean,
            default:false
        },
        productGroup:{
            type:Object,

        },
         buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            
            responseMessage:'',
            pleaseWait:false,
            
            locationList:[],
            requiredFieldLabel:'* required',
            trueParam:true
        }
    },
    computed:{
        ...mapFields([


        ]),
        
    },
    mounted(){
        this.GetLocations()
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
      
        start(){
           
            

            this.$refs.mymodal.openModal()
        },
        async save(){
           let req = {
                productGroup:this.productGroup
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addproductgroup')
            //handle response
            if(response.Successful){
                this.$emit('saved')
                this.$refs.mymodal.closeModal()
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },

       async GetLocations(){
            
                this.beforeAPI();
                var response = await this.callAPI(null,'locations')

                if(response.Successful){
                    this.locationList=response.locationList
                
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
           
        },
        
       
        
    }
}
</script>

<style>

</style>





























